import { queryClient } from '@lib/config'
import { AccountProvider } from '@lib/context/account-context'
import { CartDropdownProvider } from '@lib/context/cart-dropdown-context'
import { MobileMenuProvider } from '@lib/context/mobile-menu-context'
import { StoreProvider } from '@lib/context/store-context'
import { Hydrate } from '@tanstack/react-query'
import { CartProvider, MedusaProvider } from 'medusa-react'
import { AppPropsWithLayout } from 'types/global'
import { bhEnv } from '@lib/env'
import 'styles/globals.css'
import 'styles/fonts.css'
import 'ag-grid-community/styles/ag-grid.css'
import 'ag-grid-community/styles/ag-theme-material.css'
import '@styles/scss/shop-grid.scss'

function App({
  Component,
  pageProps,
}: AppPropsWithLayout<{ dehydratedState?: unknown }>) {
  const getLayout = Component.getLayout ?? ((page) => page)

  return (
    <MedusaProvider
      baseUrl={bhEnv.backendUrl}
      queryClientProviderProps={{
        client: queryClient,
      }}
    >
      <Hydrate state={pageProps.dehydratedState}>
        <CartDropdownProvider>
          <MobileMenuProvider>
            <CartProvider>
              <StoreProvider>
                <AccountProvider>
                  {getLayout(<Component {...pageProps} />)}
                </AccountProvider>
              </StoreProvider>
            </CartProvider>
          </MobileMenuProvider>
        </CartDropdownProvider>
      </Hydrate>
    </MedusaProvider>
  )
}

export default App
